import { Box, Typography, useTheme, Divider } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { format_Number } from '../../utils/utils';
import { setUpdateTotalVAT } from '../../store/slice/Addguest.slice';

const PaymentCard = ({
    // reservType, selectedExtraProduct, transactionDetails, languageWords,selectedCombination
    transactionPrice,excludingVat,totalVat,totalIncludingVAT,languageWords,transactionDetails
}) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  useEffect(()=>{
    dispatch(setUpdateTotalVAT(totalIncludingVAT))
  },[totalIncludingVAT])
  return (
    <Box
      sx={{
        width: '100%',
        minHeight: '220px',
      //  border: `1px dotted ${theme?.details?.detailsBorderColor}`,
        backgroundColor: theme?.palette?.background?.paper,
        borderRadius: '16px',
        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
        p: 3,
        mt: 2,
        transition: 'all 0.3s ease',
        '&:hover': {
          boxShadow: '0px 6px 14px rgba(0, 0, 0, 0.15)',
        },
      }}
    >
      <Typography
        sx={{
          color: theme?.details?.detailsHeaderColor,
          fontWeight: '600',
          fontSize: { md: '24px', sm: '20px', xs: '18px' },
          mb: 2,
        }}
      >
        {languageWords?.Payment}
      </Typography>

      {totalIncludingVAT > 0 && !isNaN(totalIncludingVAT) && (
        <>
          <Divider sx={{ mb: 2, borderColor: '#969BA0' }} />
          
      {transactionPrice > 0 && (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography sx={{ color: theme?.details?.detailsTransactionColor, fontSize: '14px',  }}>
            {transactionDetails?.languages[0]?.data}
          </Typography>
          <Typography sx={{ color: theme?.details?.detailsPriceColor, fontSize: '14px' }}>
            €{format_Number(parseFloat(transactionPrice).toFixed(2))}
          </Typography>
        </Box>
      )}
           <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
            <Typography sx={{ color: theme?.details?.detailsPriceColor, fontSize: '14px' }}>
              {languageWords['excludingVAT']}
            </Typography>
            <Typography sx={{ color: theme?.details?.detailsPriceColor, fontSize: '14px' }}>
              €{format_Number(parseFloat(excludingVat).toFixed(2))}
            </Typography>
          </Box>
        </>
      )}


      {totalVat > 0 && (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography sx={{ color: theme?.details?.detailsVatColor, fontSize: '14px'}}>
            {languageWords?.VAT}
          </Typography>
          <Typography sx={{ color: theme?.details?.detailsPriceColor, fontSize: '14px'}}>
            €{format_Number(parseFloat(totalVat).toFixed(2))}
          </Typography>
        </Box>
      )}

      {totalIncludingVAT > 0 && !isNaN(totalIncludingVAT) && (
        <>
          <Divider sx={{ mb: 2, borderColor: '#969BA0' }} />
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography sx={{ fontSize: '16px', color: theme?.details?.detailsTotalColor, fontWeight: '700' }}>
              {languageWords['TotalIncludingVAT']}
            </Typography>
            <Typography sx={{ color: theme?.details?.detailsPriceColor, fontSize: '16px', fontWeight: '700' }}>
              €{format_Number(parseFloat(totalIncludingVAT).toFixed(2))}
            </Typography>
          </Box>
        </>
      )}
    </Box>
  );
};

export default PaymentCard;

